const ITEMS = ["AI-READY", "TECH-DRIVEN", "DATA-RICH", "COORDINATED", "MULTIDISCIPLINARY", "PRECISION", "INTEGRATION", "SUSTAINABILITY"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/10 py-5 overflow-hidden bg-black" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 whitespace-nowrap">
            <span className="px-8">{item}</span>
            <span className="text-white/30">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
